<template>
  <div class="hello">
      <transition name="fade">
            <div v-if="markingOrder" class="loading">
                <p>Updating...</p>
            </div>
        </transition>

        <b-modal id="modalorderupdated">
            {{modalmessage}}
        </b-modal>

    <b-container>
        <b-row>
            <b-col>
                <h4>Out of Stock? Suggest something else</h4>
            </b-col>
        </b-row>

        <!-- Beer name -->
        <h5  v-if="setManualBeer==0" style="margin-top:20px" >Beverage</h5>
        <b-form-select v-if="setManualBeer==0" @change="selectNewBeer()" v-model="selectedDropDownBeer" :options="dropdownOptions"></b-form-select>

        <h5  v-if="setManualBeer==0" style="margin-top:20px" >Packaging</h5>
        <!-- Container -->
        <b-form-select  v-if="setManualBeer==0" @change="selectNewContainer()" v-model="selectedDropDownContainer" :options="containerDropdownOptions"></b-form-select>

        <!-- Manually Add -->
        <b-button variant="info" style="margin-top:10px" v-if="setManualBeer==0" @click="setManualBeer=1">Or, Manually Add Beverage</b-button>
         <!-- Select from inventory -->
        <b-button variant="info" style="margin-top:10px" v-if="setManualBeer==1" @click="setManualBeer=0">Or, Select from Inventory</b-button>

        <div v-if="setManualBeer==1">
            <!-- Name -->
            <b-input-group prepend="Name" class="mt-3">
                <b-form-input v-model="manualBeerName" ></b-form-input>
            </b-input-group>
            <!-- Container -->
            <b-input-group prepend="Packaging" class="mt-3">
                <b-form-input v-model="manualBeerSize" ></b-form-input>
            </b-input-group>
            <!-- Cost -->
            <!-- Invalid cost -->
            <div v-if="invalidCost" style='color:red'>
                Must enter cost in numbers only
            </div>
            <b-input-group prepend="Cost($)" class="mt-3">
                <b-form-input v-model="manualBeerCost" ></b-form-input>
            </b-input-group>
        </div>



        <!-- Seller note -->
        <b-form-textarea style="margin-top:20px" id="textarea-formatter" v-model="sellerNote" placeholder="Add an optional note"></b-form-textarea>

        <!-- Action buttons -->
        <b-row style="margin-top:20px; margin-bottom:10px">
            <b-col>
                <b-button :disabled="(!setManualBeer&&(!selectedDropDownBeer||!selectedDropDownContainer))||(setManualBeer==1&&(!manualBeerName||!manualBeerSize||!manualBeerCost))" variant="success" @click="finishEditOrder()">Suggest change to buyer</b-button>
                <b-button variant="outline-danger" style="margin-left:10px" @click="closeEditModal(0)">Cancel</b-button>
            </b-col>
        </b-row>
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')

export default {    
    props: ['theOrder'],

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'userInventory'])
    },

    components: {
    },

    data() {
        return {
            markingOrder:false,
            localOrder:{},
            selectedBeer:{},
            hasSelectedNew:false,
            dropdownOptions:[],
            containerDropdownOptions:[],
            selectedDropDownBeer:null,
            selectedDropDownContainer:null,
            modalmessage:'',
            sellerNote:'',
            manualBeerName:'',
            manualBeerSize:'',
            manualBeerCost:'',
            setManualBeer:'',
            invalidCost:false,

        }
    },

    methods:{
        //Select a new beer
        selectNewBeer(){
            console.log("Selecting new beer")
            //Check if null selected
            if(this.selectedDropDownBeer==null) return
            
            //Find the selected beer
            const existingBeerindex = this.userInventory.findIndex(item => item.docId === this.selectedDropDownBeer)
            if(existingBeerindex>-1){
                this.hasSelectedNew=true
                this.selectedBeer = this.userInventory[existingBeerindex]
                console.log("Found selected")
                console.log(this.selectedBeer)

                //Set container options
                this.containerDropdownOptions=[]
                this.containerDropdownOptions.push({ value: null, text: 'Select a package size' })
                if(this.selectedBeer.barrel1Quantity) this.containerDropdownOptions.push({ value: 'barrel1', text:  this.selectedBeer.barrel1Size + ', $ ' + this.selectedBeer.barrel1Cost})
                if(this.selectedBeer.barrel2Quantity) this.containerDropdownOptions.push({ value: 'barrel2', text:  this.selectedBeer.barrel2Size + ', $ ' + this.selectedBeer.barrel2Cost})
                if(this.selectedBeer.canQuantity) this.containerDropdownOptions.push({ value: 'cans', text:  this.selectedBeer.cansPerCase + ' Cans, $ ' + this.selectedBeer.canCost})
                if(this.selectedBeer.bottleQuantity) this.containerDropdownOptions.push({ value: 'bottles', text:  this.selectedBeer.bottlesPerCase + ' Bottles, $ ' + this.selectedBeer.canCost})
            }
        },

        //Select a new beer
        selectNewContainer(){
            console.log("Selected container: " + this.selectedDropDownContainer)

        },

        //Finish order
        finishEditOrder(){
            console.log("Finishing order docId: " + this.localOrder.docId)
            this.markingOrder=true
            //Suggest status = 1: open, 3: cancelled by buyer, 2: accepted by buyer

            this.localOrder.suggestedstatus=1
            this.localOrder.sellernote = this.sellerNote
            this.localOrder.suggestedchangedate = new Date()

            //From inventory
            if(this.setManualBeer==0){
                this.localOrder.manualbeer=0
                this.localOrder.suggestedbeerid = this.localOrder.beerId
                this.localOrder.suggestedbeername=this.selectedBeer.beerName
                //Set container
                if(this.selectedDropDownContainer=='barrel1'){
                    this.localOrder.suggestedsize=this.selectedBeer.barrel1Size
                    this.localOrder.suggestedcost=this.selectedBeer.barrel1Cost*this.localOrder.orderQuantity
                }
                else if(this.selectedDropDownContainer=='barrel2'){
                    this.localOrder.suggestedsize=this.selectedBeer.barrel2Size
                    this.localOrder.suggestedcost=this.selectedBeer.barrel2Cost*this.localOrder.orderQuantity
                }
                else if(this.selectedDropDownContainer=='cans'){
                    this.localOrder.suggestedsize=this.selectedBeer.ozPerCan + ' oz per can, ' + this.selectedBeer.cansPerCase + ' cans per case'
                    this.localOrder.suggestedcost=this.selectedBeer.canCost*this.localOrder.orderQuantity
                }
                else if(this.selectedDropDownContainer=='bottles'){
                    this.localOrder.suggestedsize=this.selectedBeer.ozPerBottle + ' oz per bottle, ' + this.selectedBeer.bottlesPerCase + ' bottles per case'
                    this.localOrder.suggestedcost=this.selectedBeer.canCost*this.localOrder.orderQuantity
                }

            }
            //Manual
            else{
                this.localOrder.manualbeer=1
                //Check cost
                if(isNaN(this.manualBeerCost)){
                    this.invalidCost=true
                    return
                } 
                else this.invalidCost=false

                //Create new beerid
                var randomIdString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                this.localOrder.suggestedbeerid=randomIdString
                this.localOrder.suggestedbeername=this.manualBeerName
                this.localOrder.suggestedsize=this.manualBeerSize
                this.localOrder.suggestedcost=this.manualBeerCost
            }
            
            fb.ordersCollection.doc(this.localOrder.docId).update(this.localOrder)
            .then(res => {
                console.log("Updated")
                this.markingOrder=false
                this.modalmessage="Order updated. An email has been sent to the buyer to accept the change."
                this.$bvModal.show("modalorderupdated")
                this.closeEditModal(1)
            }).catch(err => {
                console.log("Error editing order")
                this.markingOrder=false
                this.modalmessage="There was an error updating this order. Please try again later."
                this.$bvModal.show("modalorderupdated")
            })
            
        },

        //Close modal
        closeEditModal(success){
            console.log("Sending success: " + success)
            this.$emit('closeEditModal', this.localOrder.suborderid, success)
        }

    },

    mounted(){
        this.dropdownOptions=[]
        this.dropdownOptions.push({ value: null, text: 'Select a beverage from inventory' })
        this.localOrder = this.theOrder
        for(var i=0; i<this.userInventory.length; i++){
            this.dropdownOptions.push({value:this.userInventory[i].docId, text:this.userInventory[i].beerName})
        }
    },
}
</script>

